import { Servis } from '../services/Servis';

export const studio = {
  namespaced: true,
  state: {
    egitmenListesi: [],
    salonListesi: [],
    dersTipListesi: [],
    musteriListesi: [],
    seriListesi: [],
    yukleniyor: false,
    sonSubeGuid: null,
  },
  mutations: {
    SET_EGITMENLER(state, data) {
      state.egitmenListesi = data || [];
    },
    SET_SALONLAR(state, data) {
      state.salonListesi = data || [];
    },
    SET_DERS_TIPLERI(state, data) {
      state.dersTipListesi = data || [];
    },
    SET_MUSTERILER(state, data) {
      state.musteriListesi = data || [];
    },
    SET_SERILER(state, data) {
      state.seriListesi = data || [];
    },
    SET_YUKLENIYOR(state, val) {
      state.yukleniyor = val;
    },
    SET_SUBE_GUID(state, val) {
      state.sonSubeGuid = val;
    },
  },
  actions: {
    loadReferenceData({ commit, state }, subeGuid) {
      if (state.egitmenListesi.length > 0 && state.salonListesi.length > 0 && state.dersTipListesi.length > 0 && state.sonSubeGuid === subeGuid) return Promise.resolve();

      commit('SET_YUKLENIYOR', true);
      return Promise.all([
        Servis('POST', 'GetStudioEgitmenListesi', {}).then(function (r) {
          if (r.status === 200) commit('SET_EGITMENLER', r.data);
        }),
        Servis('POST', 'GetStudioSalonListesi', { SubeGuid: subeGuid }).then(function (r) {
          if (r.status === 200) commit('SET_SALONLAR', r.data);
        }),
        Servis('POST', 'GetStudioDersTipListesi', { SubeGuid: subeGuid }).then(function (r) {
          if (r.status === 200) commit('SET_DERS_TIPLERI', r.data);
        }),
        Servis('POST', 'GetStudioMusteriListesi', { SubeGuid: subeGuid }).then(function (r) {
          if (r.status === 200) commit('SET_MUSTERILER', r.data);
        }),
        Servis('POST', 'GetStudioSeriListesi', { SubeGuid: subeGuid }).then(function (r) {
          if (r.status === 200) commit('SET_SERILER', r.data);
        }),
      ]).finally(function () {
        commit('SET_YUKLENIYOR', false);
        commit('SET_SUBE_GUID', subeGuid);
      }).catch(function (err) {
        commit('SET_YUKLENIYOR', false);
        console.error('Studio reference data yüklenemedi:', err);
      });
    },
  },
  getters: {
    egitmenAdi: function (state) {
      return function (id) {
        var found = state.egitmenListesi.find(function (e) { return e.Studio_Egitmen_rowid === id; });
        return found ? (found.Ad + ' ' + found.Soyad) : '-';
      };
    },
    salonAdi: function (state) {
      return function (id) {
        var found = state.salonListesi.find(function (s) { return s.Studio_Salon_rowid === id; });
        return found ? found.Ad : '-';
      };
    },
    dersTipAdi: function (state) {
      return function (id) {
        var found = state.dersTipListesi.find(function (t) { return t.Studio_DersTip_rowid === id; });
        return found ? found.Ad : '-';
      };
    },
  },
};
